export default __webpack_public_path__ + "static/media/home-corporate-img-05.bb12080a.jpg";